<template>
  <range
    :label="$t('edit.sidebar.border_radius')"
    min="0"
    max="50"
    step="1"
    :value="value()"
    :change="onChange"
    :move="onMove"
  ></range>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Range from '../../../general/Range.vue';

export default {
  components: {
    Range,
  },
  methods: {
    value() {
      return this.boxConfig.trigger_button.style.borderRadius.replace('px', '');
    },
    onChange(value) {
      this.boxUpdateConfigStyle({
        item: 'trigger_button',
        rule: 'borderRadius',
        value: `${value}px`,
      });
    },
    onMove(value) {
      this.boxPreviewConfigStyleChange({
        item: 'trigger_button',
        rule: 'borderRadius',
        value: `${value}px`,
      });
    },
    ...mapActions([
      'boxUpdateConfigStyle',
      'boxPreviewConfigStyleChange',
    ]),
  },
  computed: mapGetters({
    boxConfig: 'boxConfig',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** BorderRadius.vue?3d723921
 **/